export interface CompanyProductSpec {
  label: string;
  value: string;
}

export interface CompanyProduct {
  id: string;
  name: string;
  nameKr: string;
  categoryId: string;
  categoryName: string;
  subCategoryId: string;
  subCategoryName: string;
  descriptionVi: string;
  descriptionKr: string;
  keyFeaturesVi: string[];
  keyFeaturesKr: string[];
  specs: CompanyProductSpec[];
  icon: string;
  accentColor: string;
  tags: string[];
}

export interface CompanyStrength {
  icon: string;
  titleVi: string;
  titleKr: string;
  descVi: string;
  descKr: string;
}

export interface Company {
  id: string;
  name: string;
  nameKr: string;
  taglineVi: string;
  taglineKr: string;
  descriptionVi: string;
  descriptionKr: string;
  logoFrom: string;
  logoTo: string;
  logoInitials: string;
  logoIcon: string;
  founded: string;
  location: string;
  employees: string;
  mainCategoryId: string;
  mainCategoryName: string;
  mainCategoryNameKr: string;
  strengths: CompanyStrength[];
  products: CompanyProduct[];
}

// Mock data cleared — all company data now served from Supabase (companies table)
export const companies: Company[] = [];

export const getCompanyById = (id: string): Company | undefined =>
  companies.find((c) => c.id === id);

export const getCompanyByProductId = (
  productId: string
): { company: Company; companyProduct: CompanyProduct } | undefined => {
  for (const company of companies) {
    const companyProduct = company.products.find((p) => p.id === productId);
    if (companyProduct) return { company, companyProduct };
  }
  return undefined;
};
